import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ButtonBase, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { color, r, radius } from '../../theme/tokens';

// What Membership adds, under a logged-out visitor's checked stack (STACK-563
// mock, s14). It sits below the result so the warnings are read first, and
// sells what the visitor cannot do here (design doc §1). The fine print says
// the medications are not carried into an account (Tanu, 2026-08-18).
//
// Its button goes where the "Unlock Your Personalized Stacks" banner's does.
// Whether that banner should stay above when this panel shows is open for
// Aravind (spec Decisions); both stay until he rules.

const POINTS = [
  "Keep your medications on file, so you don't re-enter them.",
  'Save this stack and come back to it.',
  'Re-check your stacks whenever your medications change.',
];

export default function GuestMembershipPanel() {
  const navigate = useNavigate();
  return (
    <Box
      component="section"
      aria-label="What Membership adds"
      data-testid="guest-membership-panel"
      sx={{
        mt: r(20),
        border: `${r(1)} solid ${color.line}`,
        backgroundColor: color.mint,
        borderRadius: radius.lg,
        py: r(16),
        px: r(18),
      }}
    >
      <Typography component="h2" sx={{ m: 0, fontSize: r(16), fontWeight: 700, color: color.evergreen }}>
        Keep checking with Membership
      </Typography>
      <Box component="ul" sx={{ listStyle: 'none', m: 0, mt: r(8), p: 0, display: 'grid', gap: r(6) }}>
        {POINTS.map((point) => (
          <Box component="li" key={point} sx={{ display: 'flex', gap: r(8), fontSize: r(14), color: color.textBody, lineHeight: 1.45 }}>
            <CheckRoundedIcon sx={{ flex: 'none', fontSize: r(16), color: color.accent, mt: r(2) }} aria-hidden />
            <span>{point}</span>
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: r(12), fontSize: r(12.5), color: color.inkSoft, lineHeight: 1.45 }}>
        The medications you added here stay in this tab and aren't carried into your account.
        After you join, you add them once in your profile.
      </Typography>
      <Box sx={{ mt: r(14), display: 'flex', flexWrap: 'wrap', gap: r(8), alignItems: 'center' }}>
        <ButtonBase
          onClick={() => navigate('/login')}
          sx={{
            minHeight: { xs: r(44), sm: r(40) },
            px: r(18),
            borderRadius: r(10),
            backgroundColor: color.accent,
            color: color.accentInk,
            fontWeight: 700,
            fontSize: r(14),
            '&:hover': { backgroundColor: color.accentHover },
          }}
        >
          Start Free Trial
        </ButtonBase>
      </Box>
    </Box>
  );
}
